// Per-testimonial data keyed by id; copy lives in the experiment i18n. Avatars
// are hosted on static.masterclass.com (allowlisted in next.config images).
export interface TestimonialLinks {
  linkedInUrl: string
  avatarUrl: string
}

export const TESTIMONIAL_LINKS: Record<string, TestimonialLinks> = {
  mikeMcgregor: {
    linkedInUrl: 'https://www.linkedin.com/in/mcgregor-mike/',
    avatarUrl: 'https://static.masterclass.com/lit-mike-mcgregor.jpeg',
  },
  brunaTalarico: {
    linkedInUrl:
      'https://www.linkedin.com/posts/brunatalarico_im-excited-to-share-that-today-we-kicked-activity-7480425142196563968-TVDT/',
    avatarUrl: 'https://static.masterclass.com/lit-bruna-talarico.jpeg',
  },
  carmenLove: {
    linkedInUrl:
      'https://www.linkedin.com/posts/carmenjayelove_ive-spent-25-years-working-across-industries-ugcPost-7474298996073635840-oNbJ/',
    avatarUrl: 'https://static.masterclass.com/lit-carmen-love.jpeg',
  },
  summerMartin: {
    linkedInUrl: 'https://www.linkedin.com/in/summergorymartin/',
    avatarUrl: 'https://static.masterclass.com/lit-summer-martin.jpeg',
  },
  ivoCooper: {
    linkedInUrl: 'https://www.linkedin.com/in/ivolutioncooper/',
    avatarUrl: 'https://static.masterclass.com/lit-ivo-cooper.jpeg',
  },
  teodoraSzasz: {
    linkedInUrl:
      'https://www.linkedin.com/posts/teodoraszasz_masterclassexecutive-masterclassexecutive-share-7480648764261814272-fsqZ/',
    avatarUrl: 'https://static.masterclass.com/lit-teodora-szasz.jpeg',
  },
  brandonMarsh: {
    linkedInUrl:
      'https://www.linkedin.com/posts/activity-7482988861485166592-aPy7',
    avatarUrl: 'https://static.masterclass.com/lit-brandon-marsh.jpeg',
  },
  karishmaChadha: {
    linkedInUrl:
      'https://www.linkedin.com/posts/karishma-c_im-currently-enrolled-in-an-mba-program-activity-7472317043107647488-mG1J',
    avatarUrl: 'https://static.masterclass.com/lit-karishma-chadha.jpeg',
  },
  samanthaFrida: {
    linkedInUrl:
      'https://www.linkedin.com/posts/activity-7485498416412745728-HXD0/',
    avatarUrl: 'https://static.masterclass.com/lit-samantha-frida.jpeg',
  },
  subramanianKalpathi: {
    linkedInUrl:
      'https://www.linkedin.com/posts/subuks_week-2-of-masterclass-executive-done-activity-7484831656361508864-P8pQ/',
    avatarUrl: 'https://static.masterclass.com/lit-subramanian-kalpathi.jpeg',
  },
}
